exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.googleIcon[data-v-c23af35a] {\n  width: 25px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/User/LoginButton.vue"],"names":[],"mappings":";AACA;EACE,YAAY;CACb","file":"LoginButton.vue","sourcesContent":["\n.googleIcon[data-v-c23af35a] {\n  width: 25px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c23af35a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/User/LoginButton.vue
// module id = 326
// module chunks = 0 6